document.addEventListener("DOMContentLoaded", function () {
  if (typeof Swiper !== "undefined" && document.querySelector(".tagSlider")) {
    let tagSwiperLoopDone = false;
    const tagSwiper = new Swiper(".tagSlider", {
      slidesPerView: "auto",
      spaceBetween: 12,
	    autoplay: {
  	    delay: 2000,
  	    disableOnInteraction: false,
  	  },
      freeMode: {
        enabled: true,
        sticky: false, // smooth free scroll, no snap
      },
      on: {
        init: function () {
          if (window.innerWidth < 768) {
            this.autoplay.start();
          }
        },
        reachEnd: function () {
          if (!tagSwiperLoopDone) {
            this.slideTo(0, 600);
            tagSwiperLoopDone = true;
          }
          
        },
        reachBeginning: function () {
          if (tagSwiperLoopDone == true) {
            this.autoplay.stop();
          }  
        }  
      },
    });

    // Restart autoplay on resize (mobile only)
    tagSwiper.on("resize", () => {
      tagSwiper.autoplay.start();
    });
  }
});
